import { Satellite, Zap, Wrench, Headphones, ShieldCheck, RefreshCw, Truck, ClipboardList, MessageCircle } from "lucide-react";
import { openWhatsApp } from "../lib/whatsapp";
import { useT } from "../lib/i18n";
import { ComingSoonSection } from "../components/site/ComingSoonSection";

export default function Services() {
    const t = useT();

    const main = [
        {
            icon: Satellite,
            title: t("New DTH Connection", "కొత్త DTH కనెక్షన్"),
            desc: t("Sun Direct connections delivered and installed at your home — antenna mount, dish alignment, set-top box configuration, and a working channel list before our technician leaves.", "మీ ఇంటిలోనే సన్ డైరెక్ట్ కనెక్షన్‌లు అందించి ఇన్‌స్టాల్ చేయబడతాయి — యాంటెన్నా మౌంట్, డిష్ అలైన్‌మెంట్, సెట్-టాప్ బాక్స్ కాన్ఫిగరేషన్, మరియు మా టెక్నీషియన్ వెళ్లేముందు పని చేసే ఛానెల్ లిస్ట్."),
            bullets: [t("Doorstep installation", "ఇంటి వద్ద ఇన్‌స్టాలేషన్"), t("Authorized hardware", "అధికారిక హార్డ్‌వేర్"), t("Setup walkthrough", "సెటప్ వాకత్రూ")],
            message: t("Hi RVS Electronics, I want a new Sun Direct connection.", "హాయ్ RVS ఎలక్ట్రానిక్స్, నాకు కొత్త సన్ డైరెక్ట్ కనెక్షన్ కావాలి."),
        },
        {
            icon: Zap,
            title: t("Recharges & Renewals", "రీఛార్జ్‌లు & రెన్యూవల్‌లు"),
            desc: t("Walk in, call, or WhatsApp — we recharge your Sun Direct subscription instantly and send you the receipt. No hidden charges, no waiting for OTPs.", "షాపుకు రండి, కాల్ చేయండి లేదా వాట్సాప్ చేయండి — మేము మీ సన్ డైరెక్ట్ సబ్‌స్క్రిప్షన్‌ను తక్షణం రీఛార్జ్ చేసి రసీదు పంపుతాము. దాచిన ఛార్జీలు లేవు, OTPల కోసం వేచి ఉండనవసరం లేదు."),
            bullets: [t("All Sun Direct packs", "అన్ని సన్ డైరెక్ట్ ప్యాక్‌లు"), t("Add-on channels", "అదనపు ఛానెల్‌లు"), t("Instant activation", "తక్షణ యాక్టివేషన్")],
            message: t("Hi RVS Electronics, I'd like to recharge my Sun Direct connection.", "హాయ్ RVS ఎలక్ట్రానిక్స్, నా సన్ డైరెక్ట్ కనెక్షన్‌ను రీఛార్జ్ చేయాలనుకుంటున్నాను."),
        },
        {
            icon: Wrench,
            title: t("Installation & Service", "ఇన్‌స్టాలేషన్ & సర్వీస్"),
            desc: t("Antenna realignment after storms, set-top box troubleshooting, signal issues, cable replacements — handled by trained technicians from RVS Electronics.", "తుఫాన్‌ల తర్వాత యాంటెన్నా రీఅలైన్‌మెంట్, సెట్-టాప్ బాక్స్ ట్రబుల్‌షూటింగ్, సిగ్నల్ సమస్యలు, కేబుల్ రీప్లేస్‌మెంట్ — RVS ఎలక్ట్రానిక్స్ శిక్షణ పొందిన టెక్నీషియన్లచే నిర్వహించబడతాయి."),
            bullets: [t("On-site visits", "ఆన్-సైట్ సందర్శనలు"), t("Quick fault diagnosis", "త్వరిత ఫాల్ట్ నిర్ధారణ"), t("Genuine spare parts", "అసలైన స్పేర్ పార్ట్‌లు")],
            message: t("Hi RVS Electronics, I need installation/service support.", "హాయ్ RVS ఎలక్ట్రానిక్స్, నాకు ఇన్‌స్టాలేషన్/సర్వీస్ సపోర్ట్ కావాలి."),
        },
        {
            icon: Headphones,
            title: t("Customer Support", "కస్టమర్ సపోర్ట్"),
            desc: t("A real person, in your language, picking up the phone. We help with billing queries, channel questions, package upgrades and complaint escalation.", "మీ భాషలో ఫోన్ ఎత్తే నిజమైన వ్యక్తి. బిల్లింగ్ సందేహాలు, ఛానెల్ ప్రశ్నలు, ప్యాకేజీ అప్‌గ్రేడ్‌లు మరియు ఫిర్యాదు పరిష్కారంలో మేము సహాయం చేస్తాము."),
            bullets: [t("Telugu · Hindi · English", "తెలుగు · హిందీ · ఇంగ్లీష్"), t("Direct distributor line", "నేరుగా డిస్ట్రిబ్యూటర్ లైన్"), t("Issue follow-through", "సమస్య అనుసరణ")],
            message: t("Hi RVS Electronics, I need help with my Sun Direct account.", "హాయ్ RVS ఎలక్ట్రానిక్స్, నా సన్ డైరెక్ట్ ఖాతాలో సహాయం కావాలి."),
        },
    ];

    const extras = [
        { icon: RefreshCw, title: t("Package Upgrades", "ప్యాకేజీ అప్‌గ్రేడ్‌లు"), desc: t("Move between Telugu, South or All-in-one packs in a single conversation.", "ఒకే సంభాషణలో తెలుగు, సౌత్ లేదా ఆల్-ఇన్-వన్ ప్యాక్‌ల మధ్య మారండి.") },
        { icon: Truck, title: t("Same-Day Visits", "అదే రోజు సందర్శనలు"), desc: t("Most installation and service jobs scheduled within 24 hours inside Armoor town.", "ఆర్మూర్ పట్టణంలోపు చాలా ఇన్‌స్టాలేషన్ మరియు సర్వీస్ పనులు 24 గంటల్లోపు షెడ్యూల్ చేయబడతాయి.") },
        { icon: ShieldCheck, title: t("Genuine Hardware", "అసలైన హార్డ్‌వేర్"), desc: t("Only authorized Sun Direct STBs and accessories — fully warranty-covered.", "కేవలం అధికారిక సన్ డైరెక్ట్ STBలు మరియు యాక్సెసరీలు — పూర్తి వారంటీతో.") },
        { icon: ClipboardList, title: t("Paperwork Done Right", "పత్రాలు సరిగా పూర్తి"), desc: t("KYC, registration and account binding completed at install — no follow-up calls needed.", "KYC, రిజిస్ట్రేషన్ మరియు ఖాతా బైండింగ్ ఇన్‌స్టాల్ సమయంలోనే పూర్తి — అదనపు కాల్‌లు అవసరం లేదు.") },
    ];

    return (
        <div data-testid="page-services">
            <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-12 md:pb-16">
                <div className="max-w-3xl">
                    <p className="eyebrow">{t("Services", "సేవలు")}</p>
                    <h1 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="mt-5 text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.02] text-rvs-navy">
                        {t("Every Sun Direct service,", "ప్రతి సన్ డైరెక్ట్ సేవ,")}<br />
                        <span className="text-rvs-orange">{t("under one roof.", "ఒకే చోట.")}</span>
                    </h1>
                    <p className="mt-7 text-lg md:text-xl text-[#4A5568] leading-relaxed">
                        {t("Whether you need a new connection, a quick recharge, or a technician to fix that snowy screen — RVS Electronics handles it end-to-end.", "మీకు కొత్త కనెక్షన్, త్వరిత రీఛార్జ్ లేదా స్క్రీన్ సమస్యను సరిచేసే టెక్నీషియన్ — RVS ఎలక్ట్రానిక్స్ ఆద్యంతం చూసుకుంటుంది.")}
                    </p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {main.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div key={i} className="card-default p-8 md:p-10 fade-up" style={{animationDelay: `${i*80}ms`}} data-testid={`service-detail-${i}`}>
                                <div className="flex items-start gap-4">
                                    <span className="w-12 h-12 rounded-xl bg-rvs-orange/10 flex items-center justify-center shrink-0">
                                        <Icon className="w-6 h-6 text-rvs-orange" />
                                    </span>
                                    <div className="flex-1">
                                        <h3 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="text-2xl font-bold text-rvs-navy tracking-tight">{s.title}</h3>
                                        <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">{s.desc}</p>
                                    </div>
                                </div>
                                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs text-rvs-navy">
                                    {s.bullets.map((b, bi) => (
                                        <li key={bi} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#FFE5D9]/40 font-semibold">
                                            <span className="w-1.5 h-1.5 rounded-full bg-rvs-orange shrink-0"></span> {b}
                                        </li>
                                    ))}
                                </ul>
                                <button
                                    onClick={() => openWhatsApp(s.message)}
                                    data-testid={`service-cta-${i}`}
                                    className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-rvs-navy link-underline"
                                >
                                    <MessageCircle className="w-4 h-4 text-rvs-orange" /> {t("Request on WhatsApp", "వాట్సాప్‌లో అభ్యర్థించండి")}
                                </button>
                            </div>
                        );
                    })}
                </div>
            </section>

            <section className="bg-white border-y border-rvs-navy-10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
                    <p className="eyebrow">{t("Why customers stay with us", "కస్టమర్‌లు మాతో ఎందుకు ఉంటారు")}</p>
                    <h2 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="mt-4 text-4xl md:text-5xl font-black tracking-tight text-rvs-navy max-w-3xl leading-[1.05]">
                        {t("The small details that turn a job into a relationship.", "పనిని సంబంధంగా మార్చే చిన్న వివరాలు.")}
                    </h2>
                    <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {extras.map((e, i) => {
                            const Icon = e.icon;
                            return (
                                <div key={i} className="card-default p-7 fade-up" style={{animationDelay: `${i*80}ms`}}>
                                    <span className="w-11 h-11 rounded-xl bg-rvs-navy text-white flex items-center justify-center">
                                        <Icon className="w-5 h-5" />
                                    </span>
                                    <h3 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="mt-6 text-lg font-bold text-rvs-navy">{e.title}</h3>
                                    <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">{e.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <ComingSoonSection />
        </div>
    );
}
